module.exports = __webpack_public_path__ + "img/1.474dc732.jpg";